import store from 'source/store';
import MilestonePageGroup from 'source/pages/root/MilestonesPageGroup.vue';

const ACCESS_DENIED = 403;

function checkIfUserIsEmployed(to, from, next) {
    const employmentLocked = store.state.auth.user?.user_profile?.is_locked;
    const workforce_id = parseInt(to.params.workforce_id);
    let userWorkforces = store.state.auth.user.user_profile.workforce_ids;
    const isWorkforceValid = !userWorkforces.includes(workforce_id);
    if (to.name === 'milestones' && employmentLocked || isWorkforceValid) {
        next({ name: 'access-denied', replace: true });
    } else {
        next();
    }
}

function isUserPermitted(workforce_id) {
    const user_profile = store.state.auth.user?.user_profile;
    if (!user_profile || user_profile.is_locked) return false;

    const workforces = user_profile.workforce_ids;
    return workforces.includes(parseInt(workforce_id));
}

async function checkIfUserIsAMilestoneMember(milestone_id) {
    try {
        await store.dispatch('milestone/milestoneMemberCheck', milestone_id);
        return true; // Success: User is allowed
    } catch (error) {
        if (error.response?.status === ACCESS_DENIED) {
            return false; // Forbidden: User not a member
        }
        throw error; // Rethrow other errors
    }
}

async function checkMilestoneRoute(to, from, next) {
    const { milestone_id, workforce_id } = to.params;

    if (!workforce_id) return;

    if (!isUserPermitted(workforce_id)) {
        return next({ name: 'access-denied', replace: true });
    }

    const isMilestoneMember = await checkIfUserIsAMilestoneMember(milestone_id);

    if (!isMilestoneMember) {
        return next({ name: 'access-denied', replace: true });
    }

    return next();
}


export default [{
    path: 'milestones',

    component: MilestonePageGroup,
    beforeEnter: checkIfUserIsEmployed,
    meta: {
        title: 'Milestones - HQZen',
        canDisplayGlobalModals: true
    },
    redirect: () => ({ name: 'milestones' }),
    children: [
        {
            path: '',
            name: 'milestones',
            component: () => import('source/pages/milestones/MilestonesPage.vue'),
            meta: {
                title: 'Milestone - HQZen',
                canDisplayGlobalModals: true,
                isInternal: true
            }
        },
        {
            path: 'milestone-details/:milestone_id',
            name: 'milestone-details',
            component: () => import('source/pages/milestones/feature/MilestoneDetailsPage.vue'),
            beforeEnter: checkMilestoneRoute,
            meta: {
                title: 'Milestone - HQZen',
                canDisplayGlobalModals: true,
                isInternal: true
            }
        },
        {
            path: 'goal-details/:milestone_id/:personal_milestone_id',
            name: 'goal-milestone-details',
            component: () => import('source/pages/milestones/goal/GoalMilestoneDetailsPage.vue'),
            meta: {
                title: 'Goal Milestone - HQZen',
                canDisplayGlobalModals: true,
                isInternal: true
            }
        },
        {
            path: 'gallery/:milestone_id',
            name: 'milestone-details-gallery-page',
            component: () => import('source/pages/milestones/ImageGalleryPage.vue'),
            meta: {
                title: 'Milestone Gallery - HQZen',
                canDisplayGlobalModals: true,
                isInternal: true
            }
        }
    ]
}];
